import { api } from "../../services";
import logo_beecrm_light_color from "../../assets/images/logo_beecrm_light_color.png"
import logo_beecrm_dark from "../../assets/images/logo_beecrm_dark.png"
// import logo_beecrm_white from "../../assets/images/logo_beecrm_white.png"
// import logo_beecrm_white_blue from "../../assets/images/logo_beecrm_white_blue.png"
import logo_beecrm_white_blue from "../../assets/images/logo_beecrm_new_colors.png"
// import logo_beecrm_white_blue from "../../assets/images/logo_beecrm_new_colors_1.png"
// import logo_beecrm_white_blue from "../../assets/images/logo_beecrm_white.png"
// import logo_beecrm_white_blue from "../../assets/images/logo_beecrm_new_white_blue.png"

import flag_br from '../../assets/images/flags/br.svg'
import flag_es from '../../assets/images/flags/es.svg'
import flag_us from '../../assets/images/flags/us.svg'

const configs = {
  state: {
    sidebar_open: false,
  sidebar_options: [
  { route: '/', permissions: 'all', route_name: 'Home', icon: 'layout-dashboard', name: 'expression_52', sub_menu_options: { routes_names: [], routes_infos: [] }, sub_menu_open: false },
  { route: '/chat', permissions: 'operator', route_name: 'Chat', icon: 'message-circle', name: 'expression_221', sub_menu_options: { routes_names: [], routes_infos: [] }, sub_menu_open: false },
  { route: '/kanban', permissions: 'all', route_name: 'Kanban', icon: 'kanban-square', name: 'expression_511', sub_menu_options: { routes_names: [], routes_infos: [] }, sub_menu_open: false },
  { route: '/gallery', permissions: 'module-supervisor-admin', route_name: 'Gallery', icon: 'image', name: 'expression_512', sub_menu_options: { routes_names: [], routes_infos: [] }, sub_menu_open: false },
  { route: '/activities', permissions: 'all', route_name: 'Activities', icon: 'check-square', name: 'expression_69', sub_menu_options: { routes_names: [], routes_infos: [] }, sub_menu_open: false },
  { route: '/leads', permissions: 'all', route_name: 'Leads', icon: 'users', name: 'expression_35', sub_menu_options: { routes_names: [], routes_infos: [] }, sub_menu_open: false },
  { route: '/campaigns', permissions: 'module-supervisor-admin', route_name: 'Campaigns', icon: 'megaphone', name: 'expression_3', sub_menu_options: { routes_names: [], routes_infos: [] }, sub_menu_open: false },
  { route: '/reports', permissions: 'all', route_name: 'Reports', icon: 'bar-chart-3', name: 'expression_59', sub_menu_open: false, sub_menu_options: { routes_names: [], routes_infos: [] }},
  { route: '/channels', permissions: 'supervisor-admin', route_name: 'Channels', icon: 'radio', name: 'expression_5', sub_menu_options: { routes_names: [], routes_infos: [] }, sub_menu_open: false },
  { route: '/users', permissions: 'supervisor-admin', route_name: 'Users', icon: 'user', name: 'expression_82', sub_menu_options: { routes_names: [], routes_infos: [] }, sub_menu_open: false },
  { route: '/settings/custom-fields', permissions: 'supervisor-admin', route_name: 'CustomFields', icon: 'settings', name: 'expression_62', sub_menu_open: false, sub_menu_options: { routes_names: [], routes_infos: [] }},
],

    current_url: null,
    domain: null,
    data: {
      note_types: [],
      user_roles: [],
      user_statuses: [],
      lead_campaigns: [],
      partner: {},
      channel_hsm: {},
      user_online: [],
    },
    chat_variables: [
      {
        name: 'Saudação',
        icon: 'bx bxs-hand',
        code: '{{SALUTATION}}'
      },
      {
        name: 'Nome do Lead',
        icon: 'bx bx-user-plus',
        code: '{{NAME}}'
      },
      {
        name: 'Nome do Operador',
        icon: 'bx bx-support',
        code: '{{OPERATOR}}'
      },
      {
        name: 'Nome do Departamento',
        icon: 'bx bx-sitemap',
        code: '{{DEPARTMENT}}'
      },
      {
        name: 'N° do Protocolo',
        icon: 'bx bx-receipt',
        code: '{{PROTOCOL}}'
      },
      {
        name: 'Link',
        icon: 'bx bx-link',
        code: '{{LINK}}'
      },
    ],
    hsm_variables: [
      {
        name: 'Saudação',
        icon: 'bx bxs-hand',
        code: '{{SALUTATION}}'
      },
      {
        name: 'Nome do Lead',
        icon: 'bx bx-user-plus',
        code: '{{NAME}}'
      },
    ],
    public_langs: [
      {
        "id": 0,
        "name": "pt_BR",
        "description": "Português",
        "flag": flag_br
      },
      {
        "id": 1,
        "name": "en",
        "description": "English",
        "flag": flag_us
      },
      {
        "id": 2,
        "name": "es",
        "description": "Español",
        "flag": flag_es
      }
    ],
    mobile: false,
    menu_mobile: false,
    loading: false,
    dark_mode: false,
    partner: {},
    report_tab: 1,
    url_docs_beecrm: 'https://docs.beecrm.io/',

    charts: {
      colors: [
        '#2b33c7',
        '#e70000',
        '#3c8239',
        '#ffbd04',
        '#8E24AA',
        '#2196F3',
        '#920000',
        '#64DD17',
        '#673AB7',
        '#F06292',
        '#009688',
        '#d5c54a',
        '#3F51B5',
        '#E91E63',
        '#5C6BC0',
        '#FF5722',
        '#880E4F',
        '#1B5E20',
        '#232489',
        '#455A64',
      ],
    },
    // TESTERS
    wizard_step: null,
    wizard_content: [
      {
        step: "0",
        icon: "",
        header_title: "",
        footer: false,
      },
      {
        step: "1",
        icon: "bx bx-qr-scan",
        header_title: "Conecte seu WhatsApp!",
        footer: false,
      },
      {
        step: "99",
        icon: "bx bx-qr-scan",
        header_title: "Conecte seu WhatsApp!",
        footer: false,
      },
    ]
  },
  getters: {
    getUserRoleObject: (state) => (key, value) => {
      const object = state.data.user_roles.find(item => {
        return item[`${key}`] === value;
      });
      return object === undefined ? {} : object;
    },
    getUserRolesArray: (state) => (key, value) => {
      if (state.data !== undefined) {
        return state.data.user_roles.filter(item => {
          return item[`${key}`] === value;
        });
      }
      return [];
    },
    getUserStatusObject: (state) => (key, value) => {
      const object = state.data.user_statuses.find(item => {
        return item[`${key}`] === value;
      });
      return object === undefined ? {} : object;
    },
    getNoteTypeObject: (state) => (key, value) => {
      const object = state.data.note_types.find(item => {
        return item[`${key}`] === value;
      });
      return object === undefined ? {} : object;
    },
    getNoteTypesArray: (state) => (key, value) => {
      if (state.data !== undefined) {
        return state.data.note_types.filter(item => {
          return item[`${key}`] === value;
        });
      }
      return [];
    },
    getTokenTimeObject: (state) => (key, value) => {
      const object = state.data.token_times.find(item => {
        return item[`${key}`] === value;
      });
      return object === undefined ? {} : object;
    },
    getTokenTimesArray: (state) => (key, value) => {
      if (state.data !== undefined) {
        return state.data.token_times.filter(item => {
          return item[`${key}`] === value;
        });
      }
      return [];
    },
    getLeadCampaignsObject: (state) => (key, value) => {
      const object = state.data.lead_campaigns.find(item => {
        return item[`${key}`] === value;
      });
      return object === undefined ? {} : object;
    },
    getUserOnlineObject: (state) => (key, value) => {
      const object = state.data.user_online.find(item => {
        return item[`${key}`] === value;
      });
      return object === undefined ? {} : object;
    },
    getWizardObject: (state) => (key, value) => {
      const object = state.wizard_content.find(item => {
        return item[`${key}`] === value;
      });
      return object === undefined ? {} : object;
    },
  },
  mutations: {
    SET_CONFIGS(state, payload) {
      // REMOVER - DEV - BEE OU PARNER
      /*payload.partner = {
        image: logo_beecrm_white_blue,
        name: "BEE CRM",
        owner: 1,
        url: "https://beecrm.io"
      }*/
      state.data = payload
    },
    SET_LOADING(state, payload) {
      state.loading = payload
    },
    SET_DARK(state, payload) {
      state.dark_mode = payload
    },
    SET_CONFIGS_PARTNER(state, payload) {
      // REMOVER - DEV - BEE OU PARNER
      state.partner = payload
    },
  },
  actions: {
    getConfigs(context) {
      api.post(`/auth/me/configs`).then(response => {
        context.commit("SET_CONFIGS", response.data);
        window.document.title = `${response.data.partner.name} - ${context.rootGetters.getTranslations('expression_916')}`
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    getPartner(context) {
      api.get(`/partner`).then(response => {
        context.commit("SET_CONFIGS_PARTNER", response.data);
        window.document.title = `${response.data.name} - ${context.rootGetters.getTranslations('expression_916')}`
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    getAuthorized(context, payload) {
      api.post(`/auth/me/authorize`, payload).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    startLoading(context) {
      context.commit("SET_LOADING", true);
    },
    stopLoading(context) {
      context.commit("SET_LOADING", false);
    },
    callWebsocket(context, payload) {
      api.post(`/4556ac60-353a-4b33-a612-a1ef8fd80d2b`, payload).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
  },
}
export default configs;
